import { QueryClient, DefaultOptions } from '@tanstack/react-query';

const defaultQueryOptions: DefaultOptions = {
	queries: {
		staleTime: 2000,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	},
};

export const createAppQueryClient = () => new QueryClient({ defaultOptions: defaultQueryOptions });
